import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenSubject = new BehaviorSubject<string | null>(null);
  public token$: Observable<string | null> = this.tokenSubject.asObservable();

  constructor() {
    const storedToken = this.getStoredToken();
    if (storedToken) {
      this.tokenSubject.next(storedToken);
    }
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
    this.tokenSubject.next(token);
    console.log('[AuthService] Token set');
  }

  getToken(): string | null {
    return this.tokenSubject.value;
  }

  getStoredToken(): string | null {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  }

  clearToken(): void {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    this.tokenSubject.next(null);
    console.log('[AuthService] Token cleared');
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp > currentTime;
    } catch (error) {
      console.error('[AuthService] Error validating token:', error);
      return false;
    }
  }

  getUserInfo(): any {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        userId: payload.sub || payload.userId,
        email: payload.email,
        roles: payload.roles || [],
        privileges: payload.privileges || []
      };
    } catch (error) {
      console.error('[AuthService] Error parsing token:', error);
      return null;
    }
  }
}

